export default __webpack_public_path__ + "static/media/IconFB.d1f88c10.svg";